module.exports = __webpack_public_path__ + "img/Utilizatori.c2b60e1f.png";